import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Menu, X } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import logoSrc from '@/assets/logo.svg'

export function LandingHeader() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const [scrolled, setScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10)
    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const navItems = [
    { label: 'Features', href: '#features' },
    { label: 'How it Works', href: '#how-it-works' },
  ]

  return (
    <header className={cn(
      "fixed top-0 left-0 right-0 z-50 transition-all duration-300"
    )}>
      <nav className="landing-header-shell">
        <div
          className={cn(
            "landing-header-panel flex items-center justify-between transition-all duration-300",
            scrolled
              ? "h-[4.7rem] bg-slate-950/76 shadow-[0_18px_60px_rgba(2,6,23,0.34)]"
              : "h-20 bg-slate-950/42 shadow-[0_12px_42px_rgba(2,6,23,0.2)]"
          )}
        >
          <div className="mx-auto flex w-full max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
            <div className="flex items-center">
              <Link to="/" className="flex items-center gap-1 group">
                <img src={logoSrc} alt="LinkToCreative" className="h-[4.5rem] object-contain brightness-0 invert" />
                <span className="bg-gradient-to-r from-white via-slate-200 to-slate-400 bg-clip-text text-xl font-bold font-brand tracking-tight text-transparent">
                  LinkToCreative
                </span>
              </Link>
            </div>

            <div className="hidden md:flex items-center space-x-8">
              {navItems.map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  className="relative py-1 text-sm font-medium text-slate-300 transition-colors hover:text-white after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-cyan-400 after:transition-all after:duration-300 hover:after:w-full"
                >
                  {item.label}
                </a>
              ))}
            </div>

            <div className="hidden md:flex items-center space-x-3">
              <Link to="/login">
                <Button variant="ghost" className="rounded-full px-4 text-slate-300 hover:bg-white/5 hover:text-white">
                  Log in
                </Button>
              </Link>
              <Link to="/register">
                <Button className="landing-cta-glow rounded-full px-5 text-sm font-semibold text-slate-950 transition-transform hover:-translate-y-0.5">
                  Get Started Free
                </Button>
              </Link>
            </div>

            <div className="md:hidden">
              <button
                type="button"
                className="rounded-full border border-white/10 bg-white/5 p-2 text-slate-200 transition-colors hover:text-white"
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              >
                {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
              </button>
            </div>
          </div>
        </div>

        {mobileMenuOpen && (
          <div className="landing-panel mb-4 rounded-3xl px-5 py-4 md:hidden animate-fade-in">
            <div className="flex flex-col space-y-4">
              {navItems.map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  className="text-sm font-medium text-slate-300 transition-colors hover:text-white"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {item.label}
                </a>
              ))}
              <div className="flex flex-col space-y-2 border-t border-white/10 pt-4">
                <Link to="/login" onClick={() => setMobileMenuOpen(false)}>
                  <Button variant="ghost" className="w-full rounded-full text-slate-200 hover:bg-white/5 hover:text-white">
                    Log in
                  </Button>
                </Link>
                <Link to="/register" onClick={() => setMobileMenuOpen(false)}>
                  <Button className="landing-cta-glow w-full rounded-full text-slate-950">
                    Get Started Free
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        )}
      </nav>
    </header>
  )
}
